import * as yup from 'yup';

import { ERROR_MSGS, PATTERNS } from '../constants';

const stringCheck = (isHideErrorMessage?: boolean) =>
  yup.string().matches(PATTERNS.SPECIAL_CHAR, {
    message: isHideErrorMessage ? ' ' : ERROR_MSGS.NO_SPECIAL_CHAR,
  });

export const createFolderSchema = yup.object().shape({
  folderName: stringCheck().required('Folder name is required'),
});
